module.exports = __webpack_public_path__ + "static/media/DS-CMS-Import-es.88bd85f2.xlsx";